import { render, staticRenderFns } from "./WxWorkCfgIndex.vue?vue&type=template&id=155c2c76&scoped=true"
import script from "./WxWorkCfgIndex.vue?vue&type=script&lang=js"
export * from "./WxWorkCfgIndex.vue?vue&type=script&lang=js"
import style0 from "./WxWorkCfgIndex.vue?vue&type=style&index=0&id=155c2c76&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c2c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155c2c76')) {
      api.createRecord('155c2c76', component.options)
    } else {
      api.reload('155c2c76', component.options)
    }
    module.hot.accept("./WxWorkCfgIndex.vue?vue&type=template&id=155c2c76&scoped=true", function () {
      api.rerender('155c2c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cfg/WxWorkCfgIndex.vue"
export default component.exports